import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "heck" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", null, "Quotes From the Stream!", -1)
const _hoisted_3 = { class: "quote-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.text, (item) => {
        return (_openBlock(), _createElementBlock("li", { key: item }, _toDisplayString(item), 1))
      }), 128))
    ])
  ]))
}